import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { AxiosCartError, Cart } from '@telialt/models/src/EshopModel';
import { getCartIdSync, getCartSession, toCartError } from '@telialt/utils/src/eshopUtils';
import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_QUERY_KEY } from '../../model';
import { apiGetCart } from '../../store/api';

type Options = Omit<UseQueryOptions<Cart, AxiosCartError, Cart>, 'queryKey' | 'queryFn'>;

export const useCartQuery = (options?: Options) => {
    const segment = useSegment();

    const {
        error,
        data: cart,
        refetch,
        isLoading,
        isRefetching,
        isFetching,
    } = useQuery<Cart, AxiosCartError, Cart>({
        retryOnMount: false,
        refetchOnMount: true,
        staleTime: 3000,
        ...options,
        queryKey: [ESHOP_QUERY_KEY.CART],
        queryFn: async () => (await apiGetCart(segment, { cartId: getCartIdSync(getCartSession()) })).data,
        enabled: options?.enabled,
    });

    const cartError = error ? toCartError(error) : null;
    const cartId = cart ? getCartIdSync(cart) : null;

    return {
        cart,
        cartId,
        cartError,
        getCart: refetch,
        cartIsLoading: isLoading,
        isRefetching,
        isFetching,
    };
};
